type validOrMsg = (value: any) => true | string

const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

class Validator {
  /** value must be present */
  static required (fieldName: string): validOrMsg {
    return (value) => !!value || `Zadajte ${fieldName}`
  }

  /** value must be email */
  static email (fieldName: string): validOrMsg {
    return (value) => emailPattern.test(value) || `${fieldName} ma nesprávny formát`
  }
}

export {
  Validator
}
